import React from 'react';
import {Grid} from '@material-ui/core';
import {MDBPopover, MDBPopoverBody} from 'mdbreact';
import {FastField} from 'formik';
import FormikCurrencySelector from 'gui/components/formikCurrencySelector/FormikCurrencySelector';
import FormikPriceInput from 'gui/components/formikPriceInput/FormikPriceInput';
import EditorSection from '../../../../../commons/editor/components/editorSection';
import {IHotelPriceDetails} from 'data/interfaces/products';

const PriceDetails = (props: { values: IHotelPriceDetails }) => {
  let roomMsg = 'המחיר בו נרכשו החדרים';
  if (props.values.roomsAmount === 1) {
    roomMsg = 'המחיר בו נרכש החדר';
  }
  return (
    <EditorSection title={roomMsg}>
      <Grid item xs={12} sm={2} md={1}>
        <MDBPopover
          placement="top"
          popover
          clickable
          domElement={true}
        >
                <span>
                  <FastField
                    component={FormikCurrencySelector}
                    label="מטבע * "
                    name="currency"
                    noBorder
                  />
                </span>
          <div>
            <MDBPopoverBody>
              מטבע של הכרטיס והשינוי שם
            </MDBPopoverBody>
          </div>
        </MDBPopover>
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <MDBPopover
          placement="top"
          popover
          clickable
          domElement={true}
        >
          <div>
            <FormikPriceInput
              label={roomMsg}
              name="totalHotelPaidPrice"
           //   name="valuePrice"
              currency={props.values.currency}
              noBorder
            />
          </div>
          <div>
            <MDBPopoverBody>
              אנא בידקו את מחירו הנוכחי של החדר על מנת לתמחר אותו במחיר ההוגן והמדוייק ביותר
            </MDBPopoverBody>
          </div>
        </MDBPopover>
      </Grid>
    </EditorSection>
  );
};

PriceDetails.defaultProps = {
  values: {},
};

export default React.memo(PriceDetails);
